import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  forwardRef,
  input,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  Validators,
} from '@angular/forms';
import { isDate, parseISO } from 'date-fns';

@Component({
  selector: 'qaroni-input-date',
  templateUrl: './input-date.component.html',
  styleUrls: ['./input-date.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDateComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class InputDateComponent implements ControlValueAccessor, OnInit {
  readonly label = input<string>('');
  readonly min = input<Date | null>(null);
  readonly max = input<Date | null>(null);
  readonly required = input<boolean>(false);

  date: FormControl<Date> = new FormControl<Date>({
    value: null,
    disabled: true,
  });

  ngOnInit(): void {
    if (this.required()) {
      this.date.addValidators(Validators.required);
      this.date.updateValueAndValidity();
    }
  }

  onChange: (value: Date | null) => void = () => undefined;

  onTouched = (): void => undefined;

  get hasDate(): boolean {
    return this.date.value !== null && this.date?.value?.toString() !== '';
  }

  writeValue(date: Date | string): void {
    if (!isDate(parseISO(date as string))) {
      return;
    }

    this.date.setValue(date as unknown as Date);
  }

  registerOnChange(fn: (value: Date | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  onClearDate(event: MouseEvent): void {
    event.stopPropagation();
    this.date.setValue(null);
    this.onTouched();
    this.onChange(this.date.value);
  }
}
